// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popover-close-btn-container {
  display: flex;
  justify-content: flex-end;
  font-size: 14px;
}

.popover-keyterm {
  font-weight: 700;
}

.keyterm-popover-btn-txt, .keyterm-popover-btn-txt > * {
  /* font-family: SFProText; */
  font-family: -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 14px;
}

.popover-close-btn-txt {
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/Components/KeytermPopover/KeytermPopover.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,0DAA0D;EAC1D,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".popover-close-btn-container {\n  display: flex;\n  justify-content: flex-end;\n  font-size: 14px;\n}\n\n.popover-keyterm {\n  font-weight: 700;\n}\n\n.keyterm-popover-btn-txt, .keyterm-popover-btn-txt > * {\n  /* font-family: SFProText; */\n  font-family: -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 14px;\n}\n\n.popover-close-btn-txt {\n  font-size: 14px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
